import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { AppBar, Hidden, Toolbar, makeStyles, Link } from "@material-ui/core";
import { Logo, Typography } from "@packages/ui";
import { Phone } from "@material-ui/icons";
import getBrandFromUrl from "../../utils/getBrandFromUrl";
import getCountryFromURL from "src/utils/getCountryFromUrl";

const brand = getBrandFromUrl();

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "white",
    borderBottom: `5px solid ${theme.palette.primary.main}`,
    zIndex: 100,
  },
  logo: {
    marginTop: 5,
    height:
      brand === "Ace"
        ? "50px"
        : brand === "Firefly"
        ? "45px"
        : brand == "Dollar"
        ? "45px"
        : brand == "Thrifty"
        ? "45px"
        : "32px",
  },
  center: {
    flexGrow: 1,
    align: "center",
  },
}));

const TopBar = ({ className, ...rest }) => {
  const classes = useStyles();
  const country = getCountryFromURL();

  return (
    <AppBar className={clsx(classes.root, className)} elevation={0} {...rest}>
      <Toolbar>
        <Logo className={classes.logo} brand={brand} />
        <Hidden mdDown>
          <Typography variant={"h5"} className={classes.center}>
            For Assistance <Phone fontSize="inherit" />{" "}
            {brand == "Thrifty" && country == "AU" ? (
              <Link href="tel:13 61 39">13 61 39</Link>
            ) : brand == "Dollar" && country == "AU" ? (
              <Link href="tel:1800 501 934">1800 501 934</Link>
            ) : country == "AU" ? (
              <Link href="tel:13 30 39">13 30 39</Link>
            ) : (
              <Link href="tel:0800 654 321">0800 654 321</Link>
            )}
          </Typography>
        </Hidden>
        <Hidden lgUp>
          <Typography variant={"h6"} className={classes.center}>
            <Phone fontSize="inherit" />{" "}
            {country == "AU" && brand == "Thrifty" ? (
              <Link href="tel:13 61 39">13 61 39</Link>
            ) : brand == "Dollar" && country == "AU" ? (
              <Link href="tel:1800 501 934">1800 501 934</Link>
            ) : country == "AU" ? (
              <Link href="tel:13 30 39">13 30 39</Link>
            ) : (
              <Link href="tel:0800 654 321">0800 654 321</Link>
            )}
          </Typography>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func,
};

export default TopBar;
